var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"id":"send_ny_vejkode","disabled":_vm.disabled},on:{"click":_vm.onButtonClick}},[_c('div',{attrs:{"id":"title"}},[_vm._v("Send")]),_c('div',{attrs:{"id":"subtitle"}},[_vm._v("til GeoDK")])])}
var staticRenderFns = []

export { render, staticRenderFns }